
import React from "react";
import "./ReportDetailsModal.css";
import { useAppContext } from "../../../../../appContext";

interface IReportDetailsModalProps {
    report: {
        userId: string;
        userName?: string;
        userFirstName?: string;
        userLastName?: string;
        timestamp: string;
        screenshotUrl?: string;
        message: string;
        logs?: Array<{
            type: string;
            message: string;
            timestamp: string;
        }>;
    };
    onClose: () => void;
}

export const ReportDetailsModal = ({ report, onClose }: IReportDetailsModalProps) => {
    const { translate } = useAppContext();
    
    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const formatDate = (timestamp: string) => {
        return new Date(timestamp).toLocaleString();
    };

    const formatLogType = (type: string) => {
        return type.toUpperCase();
    };

    const formatUserName = (report: any) => {
        if (report.userFirstName && report.userLastName) {
            return `${report.userFirstName} ${report.userLastName}`;
        }
        if (report.userName) {
            return report.userName;
        }
        return `User ID: ${report.userId}`;
    };

    return (
        <div className="ReportDetailsModal_backdrop" onClick={handleBackdropClick}>
            <div className="ReportDetailsModal">
                <div className="ReportDetailsModal_header">
                    <h2>Report Details</h2>
                    <button className="ReportDetailsModal_close" onClick={onClose}>×</button>
                </div>
                
                <div className="ReportDetailsModal_content">
                    <div className="ReportDetailsModal_section">
                        <h3>General Information</h3>
                        <div className="ReportDetailsModal_info">
                            <div className="ReportDetailsModal_info_item">
                                <strong>User:</strong> {formatUserName(report)}
                            </div>
                            <div className="ReportDetailsModal_info_item">
                                <strong>Date:</strong> {formatDate(report.timestamp)}
                            </div>
                        </div>
                    </div>

                    <div className="ReportDetailsModal_section">
                        <h3>Message</h3>
                        <div className="ReportDetailsModal_message">
                            {report.message}
                        </div>
                    </div>

                    {report.screenshotUrl && (
                        <div className="ReportDetailsModal_section">
                            <h3>Screenshot</h3>
                            <div className="ReportDetailsModal_screenshot">
                                <img 
                                    src={report.screenshotUrl} 
                                    alt={translate('alt_report_screenshot')}
                                    className="ReportDetailsModal_screenshot_image"
                                />
                            </div>
                        </div>
                    )}

                    <div className="ReportDetailsModal_section">
                        <h3>Logs ({report.logs?.length || 0})</h3>
                        <div className="ReportDetailsModal_logs">
                            {report.logs && report.logs.length > 0 ? (
                                report.logs.map((log, index) => (
                                    <div key={index} className={`ReportDetailsModal_log_item ReportDetailsModal_log_item--${log.type}`}>
                                        <div className="ReportDetailsModal_log_time">
                                            {formatDate(log.timestamp)}
                                        </div>
                                        <div className="ReportDetailsModal_log_type">
                                            [{formatLogType(log.type)}]
                                        </div>
                                        <div className="ReportDetailsModal_log_message">
                                            {log.message}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="ReportDetailsModal_no_logs">
                                    No logs available
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
